/* eslint-disable */
export default {
  topic: '모임 제목',
} as const;

// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
